module.exports = __webpack_public_path__ + "static/media/0328_IMG_LES_STRUCTURES_ILV.ea77f1b6.png";